<template>
  <button class="btn">
    <slot />
  </button>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
.btn {
  cursor: pointer;
  display: block;
  background-color: var(--brand-color, #1d8de1);
  border-radius: 0.75rem;
  color: #ffffff;
  font-size: 1rem;
  font-weight: bold;
  text-transform: uppercase;
  height: 2.75rem; // 44px
  width: 100%;
  transition: background-color 250ms;
  &.is-disabled {
    pointer-events: none;
    background-color: #dbdcdd !important;
  }
}
</style>
